/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
    if (time === 1) {
        return time + label;
    }
    return time + label + 's';
}
/**
 * @param {number} time
 */
export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time);
    if (between < 3600) {
        return pluralize(~~(between / 60), ' minute');
    }
    else if (between < 86400) {
        return pluralize(~~(between / 3600), ' hour');
    }
    else {
        return pluralize(~~(between / 86400), ' day');
    }
}
/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
    const si = [
        { value: 1E18, symbol: 'E' },
        { value: 1E15, symbol: 'P' },
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'G' },
        { value: 1E6, symbol: 'M' },
        { value: 1E3, symbol: 'k' }
    ];
    for (let i = 0; i < si.length; i++) {
        if (num >= si[i].value) {
            return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
        }
    }
    return num.toString();
}
/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
    return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}
/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
// 格式化银行账户
export function formatAccNo(accNo) {
    let result = '';
    let index = 0;
    if (accNo !== undefined && accNo != null) {
        for (let i = 0; i < accNo.length; i++) {
            result += accNo.charAt(i);
            index++;
            if (index === 4 && (i + 1 !== accNo.length)) {
                result += ' ';
                index = 0;
            }
        }
    }
    return result;
}
// 去除空格  type 1-所有空格  2-前后空格  3-前空格 4-后空格
export function trim(value, trim) {
    switch (trim) {
        case 1:
            return value.replace(/\s+/g, '');
        case 2:
            return value.replace(/(^\s*)|(\s*$)/g, '');
        case 3:
            return value.replace(/(^\s*)/g, '');
        case 4:
            return value.replace(/(\s*$)/g, '');
        default:
            return value;
    }
}
// 字母大小写切换
/* type
 1:首字母大写
 2：首页母小写
 3：大小写转换
 4：全部大写
 5：全部小写
 * */
export function changeCase(str, type) {
    function ToggleCase(str) {
        var itemText = '';
        str.split('').forEach(function (item) {
            if (/^([a-z]+)/.test(item)) {
                itemText += item.toUpperCase();
            }
            else if (/^([A-Z]+)/.test(item)) {
                itemText += item.toLowerCase();
            }
            else {
                itemText += item;
            }
        });
        return itemText;
    }
    switch (type) {
        case 1:
            return str.replace(/\b\w+\b/g, function (word) {
                return word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase();
            });
        case 2:
            return str.replace(/\b\w+\b/g, function (word) {
                return word.substring(0, 1).toLowerCase() + word.substring(1).toUpperCase();
            });
        case 3:
            return ToggleCase(str);
        case 4:
            return str.toUpperCase();
        case 5:
            return str.toLowerCase();
        default:
            return str;
    }
}
